<style lang="scss" scoped>
.download-list {
    display: flex;
    flex-direction: column;
    align-items: stretch;

    .download {
        display: flex;
        justify-content: space-between;
        align-items: center;
        border-bottom: 1px solid #f5f5f5;
        padding: 23px 9px 23px 2px;
        color: #1b1c1f;
        font-size: 0.875rem;
        font-weight: 500;
        letter-spacing: 0;
        line-height: 1.125rem;
        transition: color 0.2s;

        &:hover {
            color: #23B32F;
        }

        .title {
            display: flex;
            align-items: center;

            ::v-deep svg {
                margin-right: 10px;
            }
        }
    }

    ::v-deep svg path {
        fill: currentColor;
    }
}
</style>

<template>
    <div class="download-list">
        <a class="download" :href="media.path" target="_blank" rel="noopener" v-for="(media, index) in media" :key="index">
            <div class="title">
                <span v-html="svg('file')"></span>
                {{ media.name }}
            </div>
            <span v-html="svg('download')"></span>
        </a>
    </div>
</template>

<script>
export default {
    name: "Ui.DownloadList",

    props: {
        media: {
            type: Array,
            required: true
        }
    }
}
</script>